module.exports = __webpack_public_path__ + "static/media/singer1.59c0fccd.png";